export class SourceAccountCloudAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "aws",
            "baseName": "aws",
            "type": "AwsSourceAccountAttributes",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "GcpSourceAccountAttributes",
            "format": ""
        },
        {
            "name": "azure",
            "baseName": "azure",
            "type": "AzureSourceAccountAttributes",
            "format": ""
        },
        {
            "name": "mongoAtlas",
            "baseName": "mongoAtlas",
            "type": "MongoAtlasSourceAccountAttributes",
            "format": ""
        },
        {
            "name": "googleWorkspace",
            "baseName": "googleWorkspace",
            "type": "GoogleWorkspaceSourceAccountAttributes",
            "format": ""
        },
        {
            "name": "claudeEnterprise",
            "baseName": "claudeEnterprise",
            "type": "ClaudeEnterpriseSourceAccountAttributes",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SourceAccountCloudAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
